import type { IFlattenedCategory } from "app/common/services/categoryService.types";

// The industry ad-intelligence endpoints identify an industry by a single
// `industryKey` — the category's `forApi` key, which carries the "$" prefix
// (e.g. "$Automotive/Cars"). The backend parses main/sub category from it.
export const categoryToIndustryKey = (category: IFlattenedCategory): string => category.forApi;
